import React, { useState, useEffect } from "react";
// material
import { Card, CircularProgress, Typography } from "@mui/material";
import { Stack, Container, Button, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import Grid from "@mui/material/Grid";
import Page from "../components/Page";

import { getSetting, UpdatePrimeDescriptionSetting, getContentHistory } from "src/api/updateSetting";
import { notification } from "src/utils/messages";
import { CKEditor } from "ckeditor4-react";
import DataTable from "react-data-table-component";
import Label from "src/components/Label";
import CustomLoader from "src/components/CustomLoader";

const DescriptionEdit = () => {
  const [getdata, setgetdata] = useState({
    prime_privacy_policy_content: "",
    prime_terms_condition_content: ""
  });

  const [isLoaded, setIsLoaded] = useState(false);

  const [loading, setLoading] = useState({
    privacy: false,
    terms: false
  });

  const [confirmDialog, setConfirmDialog] = useState({ open: false, key: "" });

  const [historyData, setHistoryData] = useState([]);
  const [historyModal, setHistoryModal] = useState(false);

  const fieldMap = {
    privacy: "prime_privacy_policy_content",
    terms: "prime_terms_condition_content"
  };

  const typeMap = {
    privacy: 0,
    terms: 1
  };

  const labelMap = { privacy: "Privacy Policy", terms: "Terms & Condition" };

  async function fetchchapterlist() {
    try {
      const resp = await getSetting();
      if (resp.status == 1) {
        setgetdata(resp.data);
        setIsLoaded(true);
      }
    } catch {}
  }

  const fetchHistory = async () => {
    try {
      const resp = await getContentHistory(1);
      if (resp.status == 1) {
        setHistoryData(resp.data);
      }
    } catch {}
  };

  useEffect(() => {
    fetchchapterlist();
    fetchHistory();
  }, []);

  const lastUpdateMap = {};
  historyData.forEach((item) => {
    if (!lastUpdateMap[item.column_name]) lastUpdateMap[item.column_name] = item;
  });

  const historyColumns = [
    {
      name: "No",
      selector: (row, index) => index + 1,
      wrap: true,
      width: "70px"
    },
    {
      name: "Content",
      selector: (row) => row.column_name,
      wrap: true,
      sortable: true
    },
    {
      name: "Updated By",
      selector: (row) => row.name,
      wrap: true,
      sortable: true
    },
    {
      name: "Updated On",
      selector: (row) => row.date_time,
      wrap: true,
      sortable: true,
      width: "170px"
    },
    {
      name: "Force Re-accept",
      wrap: false,
      selector: (row) =>
        row.force_member_update == 1 ? (
          <Label variant="ghost" color="success" style={{ fontSize: "12px", fontWeight: "normal" }}>
            Yes
          </Label>
        ) : row.force_member_update == -1 ? (
          "-"
        ) : (
          <Label variant="ghost" color="default" style={{ fontSize: "12px", fontWeight: "normal" }}>
            No
          </Label>
        )
    }
  ];

  const saveField = async (key, m_force_accept) => {
    const fieldName = fieldMap[key];
    const settingData = { s_id: 1, type: typeMap[key], [fieldName]: getdata[fieldName] };
    if (m_force_accept !== undefined) settingData.m_force_accept = m_force_accept;
    setLoading((prev) => ({ ...prev, [key]: true }));
    const resp = await UpdatePrimeDescriptionSetting(JSON.stringify(settingData));
    setLoading((prev) => ({ ...prev, [key]: false }));
    notification({ type: resp.status == 0 ? "error" : "success", message: resp.message })();
    if (resp.status == 1) fetchHistory();
  };

  const handleForceAccept = (m_force_accept) => {
    const key = confirmDialog.key;
    setConfirmDialog({ open: false, key: "" });
    saveField(key, m_force_accept);
  };

  return (
    <Page title="Description Edit | Local Vocal Business Group">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h4" gutterBottom>
            Description Edit
          </Typography>
          <Button variant="contained" onClick={() => setHistoryModal(true)}>
            History
          </Button>
        </Stack>
        <Card style={{ marginBottom: "25px", padding: "25px" }}>
          <Stack spacing={10} style={{ marginBottom: "15px" }}>
            {isLoaded ? (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Stack spacing={0} style={{ marginBottom: "15px" }}>
                    <h3>Privacy Policy</h3>
                    <CKEditor
                      // key={getdata?.prime_privacy_policy_content || ""}
                      initData={getdata?.prime_privacy_policy_content || ""}
                      config={{
                        allowedContent: true,
                        extraPlugins: "colorbutton,font", // adds font + color options
                        removeButtons: "", // keep all defaults
                        colorButton_colors:
                          // 🔹 Default CKEditor palette (taken from docs)
                          "000000,993300,333300,003300,003366,000080,333399,333333," +
                          "800000,FF6600,808000,008000,008080,0000FF,666699,808080," +
                          "FF0000,FF9900,99CC00,339966,33CCCC,3366FF,800080,969696," +
                          "FF00FF,FFCC00,FFFF00,00FF00,00FFFF,00CCFF,993366,C0C0C0," +
                          "FF99CC,FFCC99,FFFF99,CCFFCC,CCFFFF,99CCFF,CC99FF,FFFFFF," +
                          // 🔹 Your extra theme colors (example: brand palette)
                          "123456,FFA500,4CAF50,9C27B0,2196F3,034766"
                      }}
                      onChange={(event) => {
                        const data = event.editor.getData();
                        setgetdata((prevData) => ({
                          ...prevData,
                          prime_privacy_policy_content: data
                        }));
                      }}
                    />
                    <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mt: 1 }}>
                      <Typography variant="caption" color="text.secondary">
                        {lastUpdateMap["Privacy Policy"]
                          ? `Last updated by ${lastUpdateMap["Privacy Policy"].name} on ${lastUpdateMap["Privacy Policy"].date_time}`
                          : ""}
                      </Typography>
                      <Button
                        onClick={() => setConfirmDialog({ open: true, key: "privacy" })}
                        variant="contained"
                        size="small"
                        disabled={loading.privacy}
                        startIcon={loading.privacy && <CircularProgress size={16} color="inherit" />}
                      >
                        Update Privacy Policy
                      </Button>
                    </Stack>
                  </Stack>
                </Grid>
                <Grid item xs={12}>
                  <Stack spacing={0} style={{ marginBottom: "15px" }}>
                    <h3>Terms & Condition</h3>
                    <CKEditor
                      // key={getdata?.prime_terms_condition_content || ""}
                      initData={getdata?.prime_terms_condition_content}
                      config={{
                        allowedContent: true,
                        extraPlugins: "colorbutton,font", // adds font + color options
                        removeButtons: "", // keep all defaults
                        colorButton_colors:
                          // 🔹 Default CKEditor palette (taken from docs)
                          "000000,993300,333300,003300,003366,000080,333399,333333," +
                          "800000,FF6600,808000,008000,008080,0000FF,666699,808080," +
                          "FF0000,FF9900,99CC00,339966,33CCCC,3366FF,800080,969696," +
                          "FF00FF,FFCC00,FFFF00,00FF00,00FFFF,00CCFF,993366,C0C0C0," +
                          "FF99CC,FFCC99,FFFF99,CCFFCC,CCFFFF,99CCFF,CC99FF,FFFFFF," +
                          // 🔹 Your extra theme colors (example: brand palette)
                          "123456,FFA500,4CAF50,9C27B0,2196F3,034766"
                      }}
                      onChange={(event) => {
                        const data = event.editor.getData();
                        setgetdata((prevData) => ({
                          ...prevData,
                          prime_terms_condition_content: data
                        }));
                      }}
                    />
                    <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mt: 1 }}>
                      <Typography variant="caption" color="text.secondary">
                        {lastUpdateMap["Terms & Condition"]
                          ? `Last updated by ${lastUpdateMap["Terms & Condition"].name} on ${lastUpdateMap["Terms & Condition"].date_time}`
                          : ""}
                      </Typography>
                      <Button
                        onClick={() => setConfirmDialog({ open: true, key: "terms" })}
                        variant="contained"
                        size="small"
                        disabled={loading.terms}
                        startIcon={loading.terms && <CircularProgress size={16} color="inherit" />}
                      >
                        Update Terms & Condition
                      </Button>
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
            ) : (
              <CustomLoader />
            )}
          </Stack>
          <Dialog open={confirmDialog.open} onClose={() => setConfirmDialog({ open: false, key: "" })}>
            {confirmDialog.key && (
              <>
                <DialogTitle>Require {labelMap[confirmDialog.key]} Acceptance</DialogTitle>
                <DialogContent>
                  <Typography>
                    Do you want to require all members to accept the updated {labelMap[confirmDialog.key]} before
                    they can continue using the platform?
                  </Typography>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => handleForceAccept(0)} variant="contained" color="inherit">
                    No, Just Update
                  </Button>
                  <Button onClick={() => handleForceAccept(1)} variant="contained">
                    Yes, Require Acceptance
                  </Button>
                </DialogActions>
              </>
            )}
          </Dialog>
          <Dialog open={historyModal} onClose={() => setHistoryModal(false)} maxWidth="md" fullWidth>
            <DialogTitle>Content History</DialogTitle>
            <DialogContent>
              <DataTable columns={historyColumns} data={historyData} pagination noHeader />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setHistoryModal(false)} variant="contained" color="inherit">
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </Card>
      </Container>
    </Page>
  );
};

export default DescriptionEdit;
